import styled from 'styled-components';

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  ${({ $isWithoutFooterPadding }) => !$isWithoutFooterPadding && `
    padding: 30px 40px;
  `}
  position: relative;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export {
  Footer,
  ButtonsContainer,
};
